export function isMarketingBrandProductFeatureSlot(index: number, isWap: boolean) {
  const position = index + 1;

  return isWap
    ? position % 4 === 1 || position % 4 === 0
    : position % 8 === 1 || position % 8 === 0;
}

export const MARKETING_BRAND_PRODUCTS_VIEW_MORE_COUNT = 8;

export function getNextMarketingBrandProductsVisibleCount(
  currentCount: number,
  totalCount: number,
) {
  return Math.min(totalCount, currentCount + MARKETING_BRAND_PRODUCTS_VIEW_MORE_COUNT);
}

function getImagePath(value: unknown): string {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (value && typeof value === 'object') {
    const record = value as Record<string, unknown>;
    return (
      getImagePath(record.url) ||
      getImagePath(record.path) ||
      getImagePath(record.src) ||
      getImagePath(record.image_url)
    );
  }

  return '';
}

function getImageGroupFirstPath(image: unknown, groupName: string): string {
  if (!image || typeof image !== 'object') {
    return '';
  }

  const group = (image as Record<string, unknown>)[groupName];
  if (!Array.isArray(group)) {
    return '';
  }

  return getImagePath(group[0]);
}

function getFiniteNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  const numberValue = Number(value);

  return Number.isFinite(numberValue) ? numberValue : undefined;
}

export function getMarketingBrandProductCelebrityImagePath(product: Record<string, unknown>) {
  const image = product.image;

  return getImageGroupFirstPath(image, 'celebrity');
}

export function getMarketingBrandProductImagePath(product: Record<string, unknown>) {
  const image = product.image;
  const productImage = getImageGroupFirstPath(image, 'product');

  return (
    productImage ||
    getImagePath(product.img_url) ||
    getImagePath(product.main_image) ||
    getImagePath(product.product_image) ||
    getImagePath(product.image_url) ||
    getImagePath(image)
  );
}

export function getMarketingBrandProductGrayImagePath(product: Record<string, unknown>) {
  const image = product.image;
  const productGrayImage = getImageGroupFirstPath(image, 'product_gray');

  return (
    productGrayImage ||
    getImagePath(product.image_gray) ||
    getImagePath(product.image_gray_url) ||
    getImagePath(product.image_product_gray)
  );
}

export function getMarketingBrandProductFeatureImagePath(product: Record<string, unknown>) {
  return (
    getMarketingBrandProductCelebrityImagePath(product) ||
    getMarketingBrandProductGrayImagePath(product) ||
    getMarketingBrandProductImagePath(product)
  );
}

export function isMarketingBrandProductSoldOut(product: Record<string, unknown>) {
  const status = getFiniteNumber(product.status);
  const stock = getFiniteNumber(product.stock);

  if (status !== undefined && status !== 1) {
    return true;
  }

  if (stock !== undefined && stock <= 0) {
    return true;
  }

  return String(product.in_stock) === '2';
}
